export default __webpack_public_path__ + "static/media/star.31b3b751.svg";